import React, { useEffect, useState } from 'react';

import { Form, Select, Tooltip, message, Modal as AntModl, Icon } from 'antd';
import { fetch } from '~helpers/graphql';
import { updateBulk } from '~settings/queries';

import { BulkEditHint } from 'common/components/svgs';
import Modal from 'common/components/modal';
import {
  depositTransferTime as deposit,
  rentTransferTime as rents,
  apCategoryEnum,
} from '~constants/landlord';
import ProcessModal from './processModal';
import { getSafeHtml } from 'common/helpers/safeHtml';

const BulkEditApCategoryModal = ({
  visible,
  t,
  selectedRowInfo,
  form,
  closeModal,
  showBulkModal,
  getPropertyTabData,
}) => {
  const [isApCategorySame, setIsApCategorySame] = useState(true);
  const [isDepositTransferSame, setIsDepositTransferSame] = useState(true);
  const [isRentTransferTimeSame, setIsRentTransferTimeSame] = useState(true);
  const [showModal, setShowModal] = useState(visible);
  const [showProceeModal, setShowProceeModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const getInitValue = () => {
    let isApCategorySame = true;

    let isDepositTransferSame = true;
    let isRentTransferTimeSame = true;
    let initApCategory = selectedRowInfo?.[0]?.apCategory;

    let initDepositTransferTime = selectedRowInfo?.[0]?.depositTransferTime;
    let initRentTransferTime = selectedRowInfo?.[0]?.rentTransferTime;
    if (selectedRowInfo?.length > 1) {
      for (let i = 1; i < selectedRowInfo?.length; i++) {
        isApCategorySame = isApCategorySame && initApCategory === selectedRowInfo[i]?.apCategory;

        isDepositTransferSame =
          isDepositTransferSame &&
          initDepositTransferTime === selectedRowInfo[i]?.depositTransferTime;

        isRentTransferTimeSame =
          isRentTransferTimeSame && initRentTransferTime === selectedRowInfo[i]?.rentTransferTime;
      }
    }

    setIsApCategorySame(isApCategorySame);
    setIsDepositTransferSame(isDepositTransferSame);
    setIsRentTransferTimeSame(isRentTransferTimeSame);
  };
  useEffect(() => {
    if (visible) {
      setShowModal(true);
      getInitValue();
    } else {
      setShowModal(false);
    }
  }, [visible]);
  const handleConfirm = () => {
    setLoading(true);
    setShowModal(false);
    setShowProceeModal(true);
    let { apCategory, depositTransferTime, rentTransferTime } = form.getFieldsValue();

    // 三个选项都为空,关闭所有modal
    if (!apCategory && !depositTransferTime && !rentTransferTime) {
      closeModal();
    } else {
      const propertyIds = selectedRowInfo?.map(item => item.id);
      const params = { propertyIds, apCategory, depositTransferTime, rentTransferTime };
      Object.keys(params)?.forEach(key => params[key] == null && delete params[key]);
      fetch(updateBulk(params))
        .then(res => {
          closeModal();
          if (res?.bulkUpdateProperties?.error) {
            setShowProceeModal(false);
            AntModl.error({
              title: t('cms.landlord.bulk_edit.error_modal_title'),
              content: 'Failed',
              centered: true,
            });
          } else {
            AntModl.success({
              title: t('cms.landlord.bulk_edit.success_modal_title'),
              content: t('cms.landlord.bulk_edit.success_modal_content', {
                num: res?.bulkUpdateProperties?.propertyIds?.length,
              }),
              okText: t('cms.properties.edit.submit.warning.btn'),
              onOk: getPropertyTabData,
              centered: true,
            });
          }
        })
        .catch(() => {
          closeModal();
          setShowProceeModal(false);

          message.error(t('cms.properties.edit.toast.error.property_not_exist'));
        });
    }
  };

  return (
    <div>
      <Modal
        centered
        visible={showModal}
        width={454}
        title={t('cms.landlord.property.bulk_edit_title')}
        onCancel={showBulkModal}
        okText={t('cms.landlord.modal.confirm.button')}
        cancelButtonProps={{ className: 'bulk-edit-apcategory__cancel-btn' }}
        cancelText={t('cms.landlord.modal.cancel.button')}
        onOk={handleConfirm}
        okButtonProps={{ loading: loading, className: 'bulk-edit-apcategory__confirm-btn' }}
      >
        <div className="bulk-edit-apcategory__box">
          <div className="bulk-edit-apcategory__hint-box">
            <BulkEditHint className="bulk-edit-apcategory__hint-svg" />
            {t('cms.properties_bulk_operation_confirm.modal.operation.selected_num', {
              num: selectedRowInfo?.length,
            })}
          </div>
          <Form layout="vertical">
            <Form.Item
              label={
                <span>
                  {t('cms.landlord.detail.ap_category.label')}
                  <Tooltip
                    placement="top"
                    title={
                      <span>{getSafeHtml(t('cms.landlord.property.bulk_apcategory_tooltip'))}</span>
                    }
                  >
                    <Icon type="question-circle" className="bulk-edit-apcategory__tooltip" />
                  </Tooltip>
                </span>
              }
            >
              {form.getFieldDecorator('apCategory', {
                initialValue: isApCategorySame ? selectedRowInfo?.[0]?.apCategory : null,
              })(
                <Select>
                  {apCategoryEnum.map(item => (
                    <Option value={item} key={item}>
                      {t(`cms.landlord.detail.ap_category.option.${item.toLowerCase()}`)}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
            <Form.Item
              label={t('cms.landlord.detail.ap_category.deposit')}
              style={{ marginTop: 24 }}
            >
              {form.getFieldDecorator('depositTransferTime', {
                initialValue: isDepositTransferSame
                  ? selectedRowInfo?.[0]?.depositTransferTime
                  : null,
              })(
                <Select>
                  {deposit.map(item => (
                    <Option value={item} key={item}>
                      {t(`cms.landlord.detail.ap_category.deposit.${item.toLowerCase()}`)}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
            <Form.Item
              label={t('cms.landlord.detail.ap_category.rent')}
              style={{ marginBottom: 32 }}
            >
              {form.getFieldDecorator('rentTransferTime', {
                // rules: [{ required: true }],
                initialValue: isRentTransferTimeSame
                  ? selectedRowInfo?.[0]?.rentTransferTime
                  : null,
              })(
                <Select>
                  {rents.map(item => (
                    <Option value={item} key={item}>
                      {t(`cms.landlord.detail.ap_category.rent.${item.toLowerCase()}`)}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Form>
        </div>
      </Modal>
      <If condition={showProceeModal}>
        <ProcessModal
          visible={showProceeModal}
          t={t}
          handleClose={() => {
            setShowProceeModal(false);
          }}
        />
      </If>
    </div>
  );
};
BulkEditApCategoryModal.displayName = 'BulkEditApCategoryModal';
export default Form.create()(BulkEditApCategoryModal);
